export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_CLOSE = 'MODAL_CLOSE';

export const modalShow = (name, data = null) => ({
    type: MODAL_SHOW,
    payload: {
        name: name,
        data: data,
    }
});

export const modalClose = name => ({
    type: MODAL_CLOSE,
    payload: {
        name: name,
    }
});